const ConstantsValues = Object.freeze({
  Roles: {
    Admin: "Admin"
  },
  Products: {
    Admin: "Admin",
    Editor: "Editor",
    Viewer: "Viewer",
    SolarOnTV: "SolarOnTV"
  },
  Rights: {
    View: "View",
    Edit: "Edit",
    Admin: "Admin"
  },
  Actions: {
    Add: "0",
    Modify: "1",
    Delete: "2"
  }
});

export default ConstantsValues;
